import script from "./HistorialDeMovimientos.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorialDeMovimientos.vue?vue&type=script&setup=true&lang=js"

import "./HistorialDeMovimientos.vue?vue&type=style&index=0&id=285ebc7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285ebc7c"]])

export default __exports__